import { type FC } from 'react';

import { useCountDownTimer } from '@/common/hooks/count-down-timer';
import { useAppSelector } from '@/redux/store';

import { UpdateContractTimerUi } from './UpdateContractTimerUi';

const UpdateDailyContractsTimer: FC = () => {
  const product = useAppSelector((state) =>
    state.contract.productOfDay?.length ? state.contract.productOfDay[0] : null,
  );
  const timeLeft = useCountDownTimer(product?.expiredIn || 0);

  return <UpdateContractTimerUi seconds={timeLeft} />;
};

export { UpdateDailyContractsTimer };
